<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas da-image"></i></span> Text
          med bild
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group
        label="Rubrik"
        :for="'ceTextImageHeadline' + content.id"
        label-sr-only
      >
        <b-form-input
          @change="updateHeadline"
          :value="content.headline"
          :id="'ceTextImageHeadline' + content.id"
          placeholder="Rubrik för texten... (valfritt)"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Ladda upp bild" :for="'ceTextImage' + content.id">
        <b-form-file
          v-model="modelImage"
          accept="image/*"
          :id="'ceTextImage' + content.id"
          browse-text="Välj bild"
          placeholder="Välj bild eller dra &amp; släpp här..."
        >
          <template slot="file-name" slot-scope="{ names }">
            <b-badge variant="primary">
              {{ names[0] }}
            </b-badge>
            <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
              + {{ names.length - 1 }} More files
            </b-badge>
          </template>
        </b-form-file>
      </b-form-group>
      <b-form-group v-if="showImage">
        <div class="ce-list">
          <label>Uppladdad fil</label>
          <div class="ce-list-item">
            <div class="ce-list-item-prefix align-items-start">
              <span style="font-size: 2.25rem" class="text-primary"
                ><img :src="imageUrl ? imageUrl.medium : ''"
              /></span>
            </div>
            <div class="ce-list-item-desc">
              <h6 class="mb-0">{{ image.name }}</h6>
            </div>
            <div class="ce-list-item-action">
              <b-button @click="removeImage" variant="flat-primary" size="sm"
                ><i class="fas fa-trash"></i
              ></b-button>
            </div>
          </div>
        </div>
      </b-form-group>
      <b-form-group>
        <TextEditor
          v-on:on-body-update="updateBody"
          :id="content.id"
          :body="content.body"
        />
      </b-form-group>
    </div>
    <div v-else :class="'ce ce-' + content.type">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <div
        v-if="imageUrl.medium"
        class="backdrop"
        :style="'background-image: url(' + imageUrl.small + ');'"
      >
        <figure class="text-center">
          <picture v-if="imageUrl.medium">
            <source media="(min-width:768px)" :srcset="imageUrl.large" />
            <source media="(min-width:776px)" :srcset="imageUrl.medium" />
            <source media="(max-width:775px)" :srcset="imageUrl.small" />
            <img :src="imageUrl.medium" :alt="image.fileName" />
          </picture>
        </figure>
      </div>
      <div class="ce-body" v-html="content.body"></div>
    </div>
  </div>
</template>

<script>
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import {
  BFormGroup,
  BFormInput,
  BFormFile,
  BBadge,
  BButton,
} from "bootstrap-vue";
import TextEditor from "@/components/quillEditor/TextEditor";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import ContentElementImageUploadMixin from "@/models/mixins/ContentElementImageUploadMixin";
import { createNamespacedHelpers } from "vuex";
import axios from "axios";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  props: {
    content: {},
    editMode: Boolean,
  },
  data() {
    return {
      imageUrl: {
        medium: null,
        small: null,
        large: null,
      },
    };
  },
  watch: {
    image(newImage) {
      this.fetchImageWithToken(newImage.medium, "medium");
      newImage.small
        ? this.fetchImageWithToken(newImage.small, "small")
        : this.imageUrl.medium;
      newImage.large
        ? this.fetchImageWithToken(newImage.large, "large")
        : this.imageUrl.medium;
    },
  },
  methods: {
    ...mapActions(["updateContent", "uploadContentImage"]),
    updateHeadline(headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    updateBody(html) {
      let content = this.content;
      content.body = html;
      this.updateContent(content);
    },
    async fetchImageWithToken(imageUrl, type) {
      try {
        const token = JSON.parse(localStorage.getItem("user")).jwt;

        const response = await axios.get(imageUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        // use the set $ to upade the imageUrls
        this.$set(this.imageUrl, type, URL.createObjectURL(response.data));
      } catch (error) {
        return "";
      }
    },
  },

  components: {
    BFormGroup,
    BFormInput,
    BFormFile,
    BBadge,
    BButton,
    TextEditor,
    CeButtonGroup,
  },
  mixins: [ContentElementButtonGroupMixin, ContentElementImageUploadMixin],
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.image-preview img {
  max-width: 30px;
}
.backdrop {
  background-repeat: no-repeat;
  background-size: cover;
}
figure {
  backdrop-filter: blur(8px) brightness(0.6);
}
picture {
  text-align: center;
  width: 100%;
}
picture img {
  max-width: 100%;
  max-height: 500px;
  width: auto;
}

.ce-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
}
.ce-list-item:last-child {
  border-bottom: none;
}
.ce-list-item-prefix {
  padding: 0.75rem 0;
}
.ce-list-item-prefix img {
  max-width: 12rem;
}
.ce-list-item-desc {
  padding: 0.75rem 0 0.75rem 0.75rem;
}
.ce-list-item-action {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  margin-right: auto;
}
</style>
